module.exports = __webpack_public_path__ + "img/gustavo-lima.47910dbb.png";